.default-alert-variant {
  --primary-color: var(--colors-neutral-ink-base);
  --background-color: var(--colors-neutral-grey-lightest);
}

.error-alert-variant {
  --primary-color: var(--colors-secondary-red-base);
  --background-color: var(--colors-secondary-red-lightest);
}

.success-alert-variant {
  --primary-color: var(--colors-secondary-green-base);
  --background-color: var(--colors-secondary-green-lightest);
}

.info-alert-variant {
  --primary-color: var(--colors-secondary-blue-base);
  --background-color: var(--colors-secondary-blue-lightest);
}

.warning-alert-variant {
  --primary-color: var(--colors-secondary-orange-base);
  --background-color: var(--colors-secondary-orange-lightest);
}

.recommend-alert-variant {
  --primary-color: var(--colors-secondary-purple-dark);
  --background-color: var(--colors-secondary-purple-lightest);
}

.icon > svg {
  min-width: var(--alert-icon-size);
  max-width: var(--alert-icon-size);
  width: var(--alert-icon-size);
  height: var(--alert-icon-size);
  color: var(--icon-color, var(--primary-color));
}
